import React from 'react';
import { Bell, Search } from 'lucide-react';

/**
 * Sticky page header used at the top of every vendor-portal page.
 * Left: H1 + subtitle. Right: optional global search + bell.
 */
export const VendorPageHeader = ({ title, subtitle, search = false, onSearch, notifyDot = false, right = null }) => (
  <div
    className="sticky top-0 z-30 bg-gray-50/85 backdrop-blur-xl border-b border-gray-200 px-6 lg:px-10 py-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
    data-testid="vendor-page-header"
  >
    <div>
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900">{title}</h1>
      {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2">
      {search && (
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
          <input
            onChange={(e) => onSearch && onSearch(e.target.value)}
            placeholder="Search…"
            className="vp-input pl-9 w-56 sm:w-64"
            data-testid="vendor-header-search"
          />
        </div>
      )}
      <button
        type="button"
        className="relative h-9 w-9 rounded-lg border border-gray-200 bg-white text-gray-500 hover:text-gray-900 hover:border-gray-300 flex items-center justify-center transition-colors"
        title="Notifications"
        data-testid="vendor-header-bell"
      >
        <Bell className="w-4 h-4" />
        {notifyDot && (
          <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-rose-500 ring-2 ring-white" />
        )}
      </button>
      {right}
    </div>
  </div>
);

export default VendorPageHeader;
